<template>
  <div class="diy-login-box" :style="{
    'min-height': minH + 'px',
  }">
    <md-card class="md-card-login" :class="{ 'md-card-hidden': cardHidden }" >
      <!-- <md-card-header :class="getClass(headerColor)">
        <slot name="title"></slot>
        <div class="social-line">
          <slot name="buttons"></slot>
        </div>
      </md-card-header> -->

      <md-card-content>
        <div class="title" v-if="this.$router.history.current.path === '/login'">
          <div style="text-align: left; flex: 1;" :class="{'selected': selected === 1}" @click="changeSelect(1)">{{$I18n("log_acc")}}</div>
          <div style="text-align: right; flex: 1;" :class="{'selected': selected === 2}" @click="changeSelect(2)">{{$I18n("cap_acc")}}</div>
        </div>
        <div class="title" v-if="this.$router.history.current.path === '/register'">
          <div style="color: #585858; margin: 0 auto; text-align: left;width: 100%;">
            {{"Welcome to register"}}
          </div>
        </div>
        <slot name="description"></slot>
        <slot name="inputs"></slot>
      </md-card-content>
      <div style="width: 100%;height: auto;flex: auto;">
        
      </div>
      <md-card-actions>
        <slot name="footer"></slot>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
export default {
  name: "login-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
    selected:{
      type: Number,
      default: 1,
    },
  },
  mounted() { },
  data() {
    let minH = 550;
    if(this.$router.history.current.path === '/login'){
      minH = 580;
    } else if(this.$router.history.current.path === '/register'){
      minH = 720;
    }
    return {
      minH : minH,
      cardHidden: true,
    };
  },
  beforeMount() {
    setTimeout(this.showCard, 400);
  },
  methods: {
    changeSelect(num){
      this.$emit('changeLoginType', num)
    },
    showCard: function () {
      this.cardHidden = false;
    },
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>
<style lang="scss" scoped>
  .title{
    width: 440px;
    font-size: 27px;
    line-height: 40px;
    margin: 45px auto 30px;
    color: #333;
    font-family: Microsoft YaHei;
    display: flex;
    font-weight: 400;
  }
  .title>div{
    transition: color .2s;
  }
  .selected{
    color: #578EFF;
  }
</style>
<style lang="css">
  .md-card-login{
    border-radius: 0;
    box-shadow: none;
    max-width: none !important;
    justify-content: center;
    /*padding-bottom: 110px;*/
  }
  h3{
    font-weight: 600;
  }
  .diy-login-box{
    display: flex;
    overflow: hidden;
    max-width: 900px;
    min-width: 590px;
    min-height: 550px;
  }
  .diy-login-box>div{
    box-shadow: 0 1px 4px 0 rgb(0 0 0 / 14%);
    border-radius: 6px;
  }
  .left-box p{
    margin: 0 0 14px 0;
    font-size: 18px;
  }
  .left-box{
    min-width: 260px;
    color: #ffffff;
    /*color: #000000;*/
    display: flex;
    font-size: 14px;
    background-color: #00bcd4;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-bottom: 32px;
  }
  @media screen and (max-width: 600px){
    .diy-login-box{
      flex-direction: column;
    }
    .left-box {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
</style>